import { StatesModule } from '@uirouter/angular';

import { ViewportComponent } from '../app-common/viewport/viewport.component';
import { SitemapComponent } from './components/sitemap/sitemap.component';

export const routes: StatesModule = {
  states: [
    {
      name: 'apps.sitemap',
      abstract: true,
      component: ViewportComponent,
    },
    {
      name: 'apps.sitemap.home',
      url: '/sitemap',
      component: SitemapComponent,
    },
  ],
};
